import { AuthProvider } from "app/contexts/JWTAuthContext";
import { SettingsProvider } from "app/contexts/SettingsContext";
import { TitleProvider } from "./contexts/titleContext";
import { Provider } from "react-redux";
import { useRoutes } from "react-router-dom";
import { MatxSnackbar, MatxTheme } from "./components";
import { Store } from "./redux/Store";
import routes from "./routes";
import { SnackbarProvider } from "notistack";
import { TracCarProvider } from "./contexts/TracCarContext";
import ServerProvider from "./views/track_car/ServerProvider";
import NativeInterface from "./views/track_car/common/components/NativeInterface";
import {SocketContext, socket} from 'app/contexts/SocketContext';
import i18n from "i18n";
import { useEffect } from "react";

const App = () => {
  const content = useRoutes(routes);

  const userRole = localStorage.getItem("userRole");
  const storedLanguage = userRole === "state"
      ? window.localStorage.getItem("stateLanguage")
      : userRole === "mis"
      ? window.localStorage.getItem("misLanguage")
      : userRole === "drc"
      ? window.localStorage.getItem("drcLanguage")
      : userRole === "brc"
      ? window.localStorage.getItem("brcLanguage")
      : userRole === "crc"
      ? window.localStorage.getItem("crcLanguage")
      : userRole === "school"
      ? window.localStorage.getItem("schoolLanguage")
      : "en";

  useEffect(() => {
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [storedLanguage]);

  return (
    <Provider store={Store}>
      <SettingsProvider>
        <SnackbarProvider>
          <TitleProvider>
             <SocketContext.Provider value={socket}>
            <MatxTheme>
              <MatxSnackbar />
              <AuthProvider>
                {content}
                <ServerProvider></ServerProvider>
                <TracCarProvider></TracCarProvider>
                <NativeInterface />
              </AuthProvider>
            </MatxTheme>
            </SocketContext.Provider>
          </TitleProvider>
        </SnackbarProvider>
      </SettingsProvider>
    </Provider>
  );
};

export default App;
